import { validatorPossui2Dependentes65anos} from "./funcoesAuxiliaresZSM";

export class CorrenteEdicaoZSM {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {

        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }
   
    infringeParentescoComAdicionalMais65(){
        if(validatorPossui2Dependentes65anos(this.dependentes,this.valoresForm) && this.valoresAnterioresForm.Idade <=65){
            this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 65 anos.')
        }
        return this
    }

}
